import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath("@pons/langenscheidt-abo-foundry", 2);
